// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"c23530dd","453":"b46299d3"}[chunkId] + ".chunk.js";
};